import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f439e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalSuccessAction",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = { class: "content mx-auto" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_9 = {
  key: 2,
  class: "text-center py-4"
}
const _hoisted_10 = { class: "d-flex justify-content-center py-4 border-top" }

import { PropType, ref, watchEffect } from 'vue'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array,
  typeModal: Object as PropType<{ type: string; title: string }>,
  reload: Function as PropType<() => void | undefined>,
  typeError: String,
},
  setup(__props) {

const props = __props



const reloadData = () => {
  props.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CI12titleModal', __props.typeModal?.title)), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: reloadData
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!__props.typeError && __props.typeModal.type === 'delete')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(translate)('CI10updateCompleted', __props.typeModal?.title.substring(2))), 1))
            : _createCommentVNode("", true),
          (!__props.typeError && __props.typeModal.type === 'approve')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('CI10updateCompletedApprove')), 1))
            : _createCommentVNode("", true),
          (!__props.typeError && __props.typeModal.type === 'reject')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(translate)('CI10updateCompletedApprove')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            onClick: reloadData
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})